// Colored pill + icon per sign-out destination, shared by the Active Sign-Outs
// list and the Following list so they render destinations identically.
// Keys match the LOCATIONS options in SignOutForm.

export const LOCATION_STYLES = {
  "Bathroom":       { emoji: "🚻", bg: "#eef3f8", color: "#3d6286" },
  "Water Fountain": { emoji: "🚰", bg: "#eaf4ff", color: "#2563eb" },
  "Nurse":          { emoji: "🏥", bg: "#fdeef0", color: "#b4231f" },
  "Library":        { emoji: "📚", bg: "#f3eefb", color: "#6b3fa0" },
  "Office":         { emoji: "🏫", bg: "#fff4e0", color: "#a35a00" },
};

export function locStyle(loc) {
  return LOCATION_STYLES[loc] || { emoji: "📍", bg: "#eef1f4", color: "#5b6675" };
}

// The fixed destination choices: the styled presets plus "Other". Anything else
// is free text a student typed into the "Other" box.
const PRESET_LOCATIONS = new Set([...Object.keys(LOCATION_STYLES), "Other"]);

// Collapse a student-typed custom destination back to "Other" for awareness-only
// views (e.g. followed classes), so one class's free text isn't broadcast to
// every teacher who follows it. The owning teacher still sees the real text on
// their own board and in history.
export function publicLocation(loc) {
  return PRESET_LOCATIONS.has(loc) ? loc : "Other";
}
